import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";

import { IRacingSecretaryStallApplicationState } from "interfaces/RacingSecretaryStallApplication";
import {
  setActiveLink,
  setStoreActiveLinkCandidate
} from "store/actions/sidebar";
import { SidebarActiveLinkReducer } from "store/reducers/sidebar";

interface IUseVetWorkoutsStoreResult {
  isRSStallApplicationDetailsOpen: boolean;
  isRSStallApplicationUnsavedChangesPopupOpen: boolean;
  redirectToLinkCandidate: () => void;
  clearLinkCandidate: () => void;
}

export const useRSStallApplicationReduxStore =
  (): IUseVetWorkoutsStoreResult => {
    const dispatch = useDispatch();
    const history = useHistory();

    const {
      isRSStallApplicationDetailsOpen,
      isRSStallApplicationUnsavedChangesPopupOpen,
      linkCandidate
    } = useSelector(
      (state: {
        racingSecretaryStallApplication: IRacingSecretaryStallApplicationState;
        sidebar: SidebarActiveLinkReducer;
      }) => {
        const { racingSecretaryStallApplication, sidebar } = state;

        return {
          isRSStallApplicationDetailsOpen:
            racingSecretaryStallApplication.stallApplicationDetailsState,
          isRSStallApplicationUnsavedChangesPopupOpen:
            racingSecretaryStallApplication.unsavedChangesPopupState,
          linkCandidate: sidebar.activeLinkCandidate
        };
      }
    );

    const redirectToLinkCandidate = () => {
      if (linkCandidate) {
        dispatch(setActiveLink(linkCandidate));
        dispatch(setStoreActiveLinkCandidate(""));
        history.push(linkCandidate);
      }
    };

    const clearLinkCandidate = () => {
      dispatch(setStoreActiveLinkCandidate(""));
    };

    return {
      isRSStallApplicationDetailsOpen,
      isRSStallApplicationUnsavedChangesPopupOpen,
      redirectToLinkCandidate,
      clearLinkCandidate
    };
  };
